module.exports = __webpack_public_path__ + "img/物流公司配置.3d4f1a85.svg";